<template>
    <div class="w-full h-full flex flex-col p-6 lg:p-10 bg-gray-100">
        <div class="w-full h-full">
            <div class="w-full flex flex-row justify-between items-center mb-5 ">
                <h1 class="text-theme-primary text-3xl font-semibold">Events</h1>
            </div>

            <div
                class="lg:col-span-2 mb-auto flex flex-col justify-center items-start p-4 lg:p-7 bg-white rounded-2xl shadow-sm overflow-clip pb-10">

                <div class="w-full flex flex-col lg:flex-row items-start lg:items-center justify-between mb-5">
                    <p
                        class="px-3 py-1 text-gray-600 font-medium text-2xl border-l-8 border-theme-secondary mb-4 lg:mb-0">
                        PAPSI Run 2025</p>
                    <div class="w-full lg:w-1/2 flex flex-col lg:flex-row items-end space-x-2 space-y-3 lg:space-y-0">
                        <div  class="w-full">
                            <Button 
                                v-if="isDevelopmentMode"
                                @click="handleButtonClick('https://dev.papsirun.pafcpic.net/registration')"
                                :button_text="lang('Register')" 
                                :disabled="!isRegistrationOpen"
                            />
                            <Button 
                                v-else
                                @click="handleButtonClick('https://papsirun.pafcpic.net/registration')"
                                :button_text="lang('Register')" 
                                :disabled="!isRegistrationOpen"
                            />
                        </div>
                        <Button is_secondary :button_text="lang('View Registrants')"
                            @click="viewRegistrants" class="truncate"/>
                    </div>
                </div>

                <div class="w-full">
                    <img src="https://resource.pafcpic.net/assets/funrun/papsi_run_2025.jpg" class="rounded-xl">
                </div>

                <div class="w-full flex flex-col mt-10" v-show="!regEnded">
                    <div
                        class="text-theme-primary text-lg leading-4 uppercase font-bold text-center italic items-center justify-center flex w-full mb-5">
                        <p>- {{ label }} -</p>
                    </div>
                    <div class="w-full flex justify-center gap-2 flex-wrap md:flex-nowrap">
                        <Tick :value="days.toString()" label="Days" margin />
                        <Tick :value="hour.toString()" label="Hrs" margin />
                        <Tick :value="minute.toString()" label="Mins" margin />
                        <Tick :value="seconds.toString()" label="Secs" />
                    </div>
                </div>

            </div>


            <ModalControl v-show="show_message_modal" v-bind:display="show_message_modal" :error="this.error"
                :success="this.success" :note="this.warning" z_value="z-50" @positiveClick="handlePositiveClick()"
                :positiveButton="'OK'" :default_width="'max-w-xl'" id='vote_modal'>
                <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center">
                    {{ this.modal_message }}
                </div>
            </ModalControl>

            <ModalControl v-show="view_registrants" v-bind:display="view_registrants" z_value="z-50"
                :default_width="'max-w-3xl'" closable @closed="view_registrants = false" id="registrants_modal">
                <div class="w-full px-6 py-4 flex flex-col gap-4 pt-10">
                    <h2 class="text-2xl font-semibold text-theme-primary text-left mb-4">
                        Registered Participants
                    </h2>

                    <div v-if="registrants.length > 0" class="space-y-4 overflow-y-auto pr-2">
                        <div v-for="(item, index) in registrants" :key="index"
                            class="border border-gray-200 rounded-xl shadow-sm p-4 flex flex-col lg:flex-row items-start lg:items-center justify-between hover:shadow-md transition">
                            <!-- Left side - Details -->
                            <div class="flex flex-col items-start text-left w-full lg:w-2/3">
                                <p class="text-lg font-semibold text-gray-600">
                                    {{ item.fname }} {{ item.mname ? item.mname + ' ' : '' }}{{ item.lname }}
                                </p>
                                <p class="text-sm text-gray-500">
                                    <strong>Run Key:</strong> {{ item.run_reg_key }}
                                </p>
                                <p class="text-sm text-gray-500">
                                    <strong>Gender:</strong> {{
                                        item.gender === "M"
                                            ? "Male"
                                            : item.gender === "F"
                                                ? "Female"
                                                : item.gender === "X"
                                                    ? "Rather not say"
                                                    : item.gender
                                    }} | <strong>Age:</strong> {{ item.age }}
                                </p>
                                <p class="text-sm text-gray-500">
                                    <strong>Segment:</strong> {{ item.segment.fslot_name }}
                                </p>
                                <p class="text-sm text-gray-500">
                                    <strong>Category:</strong>
                                    {{
                                        item.category === "1"
                                            ? "Fun Run"
                                            : item.category === "2"
                                                ? "Zumba"
                                                : item.category === "3"
                                                    ? "Both Fun Run and Zumba"
                                                    : item.category
                                    }} <span v-if="item.distance">| <strong>Distance:</strong> {{ item.distance }}</span>
                                    
                                </p>
                                <p v-if="item.sponsor_type" class="text-sm text-gray-500">
                                    <strong>Sponsor Type:</strong> {{ item.sponsor_type }}
                                </p>
                                <p v-if="item.branch_service" class="text-sm text-gray-500">
                                    <strong>Branch Service:</strong> {{ item.branch_service }}
                                </p>
                                <p v-if="item.acct_no" class="text-sm text-gray-500">
                                    <strong>Account Number:</strong> {{ item.acct_no }}
                                </p>
                                <p class="text-sm text-gray-500">
                                    <strong>Email Address:</strong> {{ item.email }}
                                </p>
                                <p class="text-sm text-gray-500">
                                    <strong>Mobile Number:</strong> {{ item.mobile }}
                                </p>
                                <p class="text-sm text-gray-500">
                                    <strong>Registered:</strong> {{ formatDate(item.registration_date) }}
                                </p>
                                <p class="mt-1 text-sm font-medium"
                                    :class="item.claimed ? 'text-green-600' : 'text-red-500'">
                                    Status: {{ item.claimed ? 'Claimed' : 'Not Claimed' }}
                                </p>
                            </div>

                            <!-- Right side - QR Code -->
                            <div class="w-full lg:w-auto flex justify-center mt-4 lg:mt-0">
                                <qrcode-vue :value="item.qr_code" :size="120" level="M"
                                    class="border p-2 rounded-lg bg-white" />
                            </div>
                        </div>
                    </div>

                    <div v-else class="text-center text-gray-500 py-6">
                        No registrants found.
                    </div>
                </div>
            </ModalControl>

        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import Button from "@/components/controls/ButtonControl.vue";
import User from "@/services/User";
import QrcodeVue from 'qrcode.vue';
import Tick from "@/components/controls/TickControl.vue";
import mixin from '@/mixin';

export default defineComponent({
    components: {
        ModalControl,
        Button,
        QrcodeVue,
        Tick
    },
    mixins: [mixin],
    inject: ['setLoading'],
    mounted() {
        let that = this;
        const state = that.$store.state;

        if (!state.credentials.username) {
            that.getUserInfo();
        } else {
            that.checkUserFlow();
        }

    },
    data() {
        return {
            items: [],
            registrants: [],
            view_registrants: false,
            show_message_modal: false,
            modal_message: '',
            success: false,
            warning: false,
            error: false,
            question: false,
            expired: false,
            days: 0,
            hour: 0,
            minute: 0,
            seconds: 0,
            label: "Event Countdown",
            regEnded: false,
            intervalId: null,
            isRegistrationOpen: false,
        }
    },
    computed: {
        sched() {
            return this.$store.state.sched;
        },
        isDevelopmentMode() {
            return process.env.VUE_APP_DEVELOPMENT_MODE === 'true';
        },
    },
    watch: {
        sched: {
            handler(newVal) {
                if (newVal?.event_date) {
                    this.startCountdown(newVal.event_date);
                }
            },
            immediate: true,
        },
    },
    beforeUnmount() {
        if (this.intervalId) clearInterval(this.intervalId);
    },
    methods: {
        startCountdown(targetDate) {
            if (this.intervalId) clearInterval(this.intervalId);

            const eventDate = new Date(targetDate).getTime();

            this.intervalId = setInterval(() => {
                const now = new Date().getTime();
                const distance = eventDate - now;

                if (distance <= 0) {
                    clearInterval(this.intervalId);
                    this.days = this.hour = this.minute = this.seconds = 0;
                    this.regEnded = true; // ✅ hide countdown when event done
                    return;
                }

                this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
                this.hour = Math.floor(
                    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                );
                this.minute = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
            }, 1000);
        },
        getRunSched() {
            this.setLoading(true);
            User.getRunSched()
                .then((response) => {
                    this.setLoading(false);
                    this.$store.state.sched = response.data.data[0];

                    const sched = this.$store.state.sched;

                    // 🕒 Start countdown if there's an event date
                    if (sched?.event_date) {
                        this.startCountdown(sched.event_date);
                    }

                    // ✅ Determine if registration is open right here
                    if (sched?.registration_start && sched?.registration_end) {
                        const today = new Date();
                        const startDate = new Date(sched.registration_start);
                        const endDate = new Date(sched.registration_end);

                        // Optional adjustment (if you want registration to end the day before)
                        // endDate.setDate(endDate.getDate() - 1);

                        this.isRegistrationOpen = today >= startDate && today <= endDate;
                    } else {
                        this.isRegistrationOpen = false;
                    }
                })
                .catch((error) => {
                    if (error.response?.status == 403) {
                        this.expired = true;
                        this.modal_message = "Your session has expired. Please log in again.";
                        this.$store.state.logged = false;
                    }
                    this.setLoading(false);
                    this.error = true;
                    this.show_message_modal = true;
                    this.modal_message = error.response?.data?.message || "Failed to load registrants.";
                });
        },
        handleButtonClick(link) {
            if (!link) return;

            // Get credentials safely
            const credentials = this.$store?.state?.credentials || {};
            console.log('data: ', credentials);

            if (link.startsWith("http")) {
                const fname = encodeURIComponent(credentials.first_name || "");
                const mname = encodeURIComponent(credentials.middle_name || "");
                const lname = encodeURIComponent(credentials.last_name || "");
                const email = encodeURIComponent(credentials.email || "");
                const mobile = encodeURIComponent(credentials.mobile || "");
                const age = encodeURIComponent(credentials.age || "");
                const gender = encodeURIComponent(credentials.gender || "");
                const account_no = encodeURIComponent(credentials.account_no || "");
                const membership_type = encodeURIComponent(credentials.membership_type || "");
                const uuid = encodeURIComponent(credentials.uuid || "");

                const urlWithParams = `${link}${link.includes("?") ? "&" : "?"}fname=${fname}&mname=${mname}&lname=${lname}&email=${email}&mobile=${mobile}&age=${age}&gender=${gender}&account_no=${account_no}&membership_type=${membership_type}&uuid=${uuid}`;

                window.open(urlWithParams, "_blank");
            } else {
                // Internal: navigate normally
                this.$router.push(link);
            }
        },
        viewRegistrants() {
            let that = this;
            this.setLoading(true);

            User.getRegistrants(this.$store.state.credentials.uuid)
                .then(function (response) {
                    if (!response.data.data) {
                        that.setLoading(false);
                        that.success = false;
                        that.error = false;
                        that.warning = true;
                        that.show_message_modal = true;
                        that.modal_message = 'No registrants found';
                    } else {
                        that.setLoading(false);
                        that.registrants = response.data.data; // 👈 assign data here
                        that.view_registrants = true;
                    }
                })
                .catch(function (error) {
                    if (error.response?.status == 403) {
                        that.expired = true;
                        that.modal_message = "Your session has expired. Please log in again.";
                        that.$store.state.logged = false;
                    }
                    that.setLoading(false);
                    that.error = true;
                    that.show_message_modal = true;
                    that.modal_message = error.response?.data?.message || 'Failed to load registrants.';
                });
        },
        closed() {
            let that = this;
            that.$cookies.remove('user');
            that.$cookies.remove('user_session');
            that.$router.push('/');
            that.show_message_modal = false;
        },
        formatDate(date) {
            if (!date) return '—';
            const d = new Date(date);
            return d.toLocaleString('en-PH', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        getUserInfo() {
            let that = this;
            const cookie = that.$cookies;
            const store = that.$store;
            let state = store.state;
            that.setLoading(true);

            User.recoverSession(cookie.get('user_session').hash).then(function (response) {
                let data = response.data.data;
                state.logged = true;
                state.credentials.first_name = data.info.first_name;
                state.credentials.last_name = data.info.last_name;
                state.credentials.middle_name = data.info.middle_name;
                state.credentials.regular = data.info.regular;
                state.credentials.express = data.express;
                state.credentials.pso_enroll = data.pso_enroll;
                state.credentials.pin_update = data.pin_update;
                state.credentials.membership_date = data.info.membership_date || null;
                state.credentials.status = data.status || null;
                state.credentials.account_no = data.info.account_number;
                state.credentials.email = data.info.email;
                state.credentials.gender = data.info.gender;
                state.credentials.birthdate = data.info.date_of_birth;
                state.credentials.age = data.info.age;
                state.credentials.membership_type = data.info.membership_type;
                state.credentials.registered_date = data.info.registered;
                state.credentials.key = data.key;
                state.credentials.mobile = data.info.mobile;
                state.credentials.name = data.info.first_name + " " + data.info.last_name + (data.info.suffix ? " " + data.info.suffix : "");
                state.credentials.suffix = data.info.suffix ?? '';
                state.credentials.qr = data.qr;
                state.credentials.uuid = data.uuid;
                state.credentials.serial_no = data.info.serial_number;
                state.credentials.timestamp = response.timestamp;
                state.credentials.username = data.info.username;
                state.credentials.hash = data.hash;
                state.credentials.has_pin = data.has_pin;
                state.credentials.deactivated = data.deactivated;
                state.credentials.tin = data.info.tin;
                const type2Config = data.config.find(item => item.type === 2);
                if (type2Config) {
                    state.credentials.config = { status: type2Config.status };
                } else {
                    state.credentials.config = null;
                }
                that.account_number = state.credentials.account_no;
                that.full_name = state.credentials.name;
                that.gender = state.credentials.gender;
                that.Astatus = state.credentials.status;
                that.Membership = state.credentials.membership_type;
                that.Member_since = state.credentials.membership_date;
                that.email = state.credentials.email;
                that.mobile = state.credentials.mobile;
                that.tin = state.credentials.tin;
                that.age = state.credentials.age;
                that.birthdate = state.credentials.birthdate;
                that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
                that.username = state.credentials.username;
                that.registered = state.credentials.registered_date;
                that.qr = data.qr;
                that.currentTin = state.credentials.tin;
                that.express = data.express;
                that.deactivated = data.deactivated;
                const rawRegisteredDate = state.credentials.registered_date;
                if (rawRegisteredDate) {
                    const parts = rawRegisteredDate.split('-');
                    that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                const rawBirthdate = state.credentials.birthdate;
                if (rawBirthdate) {
                    const parts = rawBirthdate.split('-');
                    that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                that.checkUserFlow();
                that.setLoading(false);

            }).catch(function (error) {
                that.error = true;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                if (error.response.status == 403) {
                    that.expired = true
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.$store.state.logged = false;
                }
            });
        },
        checkUserFlow() {
            const that = this;
            const state = that.$store.state;
            const noContact = !state.credentials.mobile || !state.credentials.email;
            const config = state.credentials.config;
            const temporaryPIN = state.credentials.pin_update;
            const isValidated = that.$cookies.get('validated');

            this.getRunSched();

            if (state.credentials.deactivated) {
                this.$router.push('/user/settings');
                return;
            }

            if (noContact) {
                state.credentials.noContact = noContact;
                this.show_update = true;
                return;
            }

            if (state.credentials.enrolled_pin) {
                const hasValidConfig = config && config.status;
                const noContact = state.credentials.noContact;
                state.credentials.enrolled_pin = false;

                if (noContact) {
                    that.show_update = false;
                    that.show_pin_modal = false;
                    that.show_otp_modal = false;
                    that.$cookies.set('validated', true);
                } else {
                    if (hasValidConfig) {
                        that.requestOTP();
                    } else {
                        that.show_update = false;
                        that.show_pin_modal = false;
                        that.show_otp_modal = false;
                        that.$cookies.set('validated', true);
                    }
                }
                return;
            }


            if (!isValidated) {
                if (state.credentials.has_pin) {
                    this.show_pin_modal = true;
                } else {
                    this.$router.push('/user/settings');
                }
            }

            if (temporaryPIN) {
                this.$router.push('/user/settings');
                state.credentials.edit_temporary = true;
                return;
            }

            const missingInfo = !state.credentials.mobile || !state.credentials.email ||
                !state.credentials.tin || !state.credentials.birthdate;

            if (missingInfo && !that.$cookies.get('skipped')) {
                this.show_update = true;
            }
        },
        toTitleCase(str) {
            return str
                .toLowerCase()
                .replace(/\b\w/g, (char) => char.toUpperCase());
        },
        handlePositiveClick() {
            if (this.expired) {
                this.closed();
            } else {
                this.show_message_modal = false;
                this.show_pin_modal = false;
                this.pin_value = '';
            }
        },
    },
})
</script>
<style scoped>
.max-width-back {
    max-width: 50px;
}
</style>
